import React from 'react'
import ContactUs from '../Components/ContactUs/ContactUs'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Header/Header'
import Payment from '../Components/Payment/Payment'
import TopNavbar from '../Components/TopNavbar/TopNavbar'

const PaymentPage = () => {
  return (
    <>
    <TopNavbar/>
    <Header/>
    <Payment/>
    <ContactUs/>
    <Footer/>
    </>
  )
}

export default PaymentPage